import { roles as roleKeys, affiliationGroups as affGroups } from 'keys'
import { allRoles } from 'keys/roles'
import { semesterAndYearOptions } from 'keys/years'
import { map, uniqueId } from 'lodash'

class User {

    constructor(user, data) {
        const { id, tz, filled_fields, initial_pass, username, first_name, last_name, phone_number, gender, email, user_roles } = user

        this.id = id
        this.initial_pass = initial_pass
        this.first_name = first_name
        this.last_name = last_name
        this.phone = phone_number
        this.tz = tz
        this.gender = gender
        this.email = email
        this.username = username
        // this.user_roles = getUserRoles(user_roles, data)

        this.filled_fields = filled_fields
    }
}

export const getUserRoles = (userRoles, data) => {
    const { grades, affiliationGroups, affiliations, schoolClasses, learningGroups, testTakers, roles } = data
    let nUserRoles = []

    let nAffiliations = {}

    userRoles.forEach(userRole => {
        const {
            group, group_name,
            affiliation,
            grade,
            learning_unit,
            test_taker,

            role, role_name, school_year
        } = userRole
        const roleType = allRoles[role_name]

        const isSchoolGroup = group_name == affGroups.schools

        const nAffiliationGroup = affiliationGroups.find(aff => aff.id == group)
        const nAffiliation = affiliations.find(aff => aff.id == affiliation)
        const nGrade = grades.find(gr => gr.id == grade)
        // אנחנו מאתרים את הכיתה/קבוצה לפי id 
        const nClass = schoolClasses.find(cl => cl.id == learning_unit)
        const nGroup = learningGroups.find(cl => cl.id == learning_unit)

        const nTestTaker = testTakers.find(te => te.test_taker_id == test_taker)
        const nRole = roles.find(ro => ro.id == role)
        const nSchoolYear = semesterAndYearOptions.find(item => item.id == school_year)

        //if the school not exist in userRoles
        if (!nAffiliations[affiliation])
            nAffiliations[affiliation] = {
                affiliation: nAffiliation,
                affiliationGroup: nAffiliationGroup,
                roles: {}
            }

        if (roleType == roleKeys.principal)
            nAffiliations[affiliation].roles[role_name] = {
                id: uniqueId(),
                role: nRole,
                school_year: nSchoolYear,
                data: []
            }

        else if (!nAffiliations[affiliation].roles[role_name]) {
            if (roleType == roleKeys.coordinator) {
                nAffiliations[affiliation].roles[role_name] = {
                    role: nRole,
                    school_year: nSchoolYear,
                    id: uniqueId(),
                    data: [{
                        id: uniqueId(),
                        grades: [nGrade]
                    }]
                }
            }
            if (roleType == roleKeys.teacher) {
                nAffiliations[affiliation].roles[role_name] = {
                    role: nRole,
                    school_year: nSchoolYear,
                    id: uniqueId(),
                    data: isSchoolGroup ?
                        [{
                            id: uniqueId(),
                            classes: [nClass],
                            learning_groups: [nGroup],
                            grade: nGrade,
                        }] :
                        [{
                            id: uniqueId(),
                            learning_groups: [nGroup]
                        }]
                }
            }
            if (roleType == roleKeys.single) {
                nAffiliations[affiliation].roles[role_name] = {
                    role: nRole,
                    school_year: nSchoolYear,
                    id: uniqueId(),
                    data: [{
                        id: uniqueId(),
                        grade: nGrade,
                        school_class: nClass,
                        test_takers: [nTestTaker]
                    }]
                }
            }
        }
        else {
            if (roleType == roleKeys.coordinator) {
                nAffiliations[affiliation].roles[role_name].data[0].grades.push(nGrade)//need to convert to pulldwon data
            }
            else if (roleType == roleKeys.teacher) {
                const currentIndex = nAffiliations[affiliation].roles[role_name].data.findIndex(item => item.grade?.id == grade)
                if (currentIndex != -1) {
                    nAffiliations[affiliation].roles[role_name].data[currentIndex].classes.push(nClass)
                }
                else {
                    nAffiliations[affiliation].roles[role_name].data.push({
                        id: uniqueId(),
                        grade: nGrade,
                        classes: [nClass]
                    })
                }

            }
            else if (roleType == roleKeys.single) {
                const currentIndex = nAffiliations[affiliation].roles[role_name].data.findIndex(item => item.grade.id == grade && item.learning_unit?.id == learning_unit)
                if (currentIndex != -1) {
                    nAffiliations[affiliation].roles[role_name].data[currentIndex].test_takers.push(nTestTaker)
                }
                else {
                    nAffiliations[affiliation].roles[role_name].data.push({
                        id: uniqueId(),
                        grade: nGrade,
                        school_class: nClass,
                        test_takers: [nTestTaker]
                    })
                }
            }
        }
    })

    nUserRoles = map(nAffiliations)

    nUserRoles.forEach((_, userRoleIndex) => {
        nUserRoles[userRoleIndex].roles = map(nUserRoles[userRoleIndex].roles)
    });

    return nUserRoles
}

export default User